import * as React from 'react';

//hook
import { useState } from 'react';
import { NotificationConsumer } from '../hooks/context/NotificationContext';
import { UserConsumer } from '../hooks/context/UserContext';

//component
import InputField from '../component/fields/InputField';
import PhoneField from '../component/fields/PhoneField';

//type
import { signupReqType } from '../api/signup/type/SignupType';

//api
import { PostSignupApi } from '../api/signup/PostSignupApi';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

//mui icon
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//image
import apple from "../assets/login/apple.png"
import google from "../assets/login/google.png"

import { requestNotificationPermission } from '../firebase/notifgicationFireBase';
import { useApi } from '../hooks/useApi';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface signupProps {
  openSignup: boolean,
  setOpenSignup: (open: boolean) =>void
  setOpenOtp: (open: boolean) =>void
}


const Signup = ({openSignup, setOpenSignup, setOpenOtp} : signupProps) => {
  const { t } = useTranslation();
  const [showPass, setShowPass] = useState<boolean>(false)
  let {setUserData} = UserConsumer()
  const {
    loading: signupLoading,
    error: signupError,
    HandlerApi: signupApi,
  } = useApi(PostSignupApi, "Post");

  const SignupSchema = Yup.object().shape({
    full_name: Yup.string().required(t("full_name_required")),
    email: Yup.string().email(t("invalid_email")).required(t("email_required")),
    password: Yup.string().min(8, t("password_lenght")).required(t("password_required")),
    phone: Yup.string()
      //test(name, message, testFunction)
      .test(
        "len",t("phone_lenght"),
        (value) => {
          if (!value) return false;
          const numberWithoutCode = value.slice(4);
          return numberWithoutCode.length == 9 && !numberWithoutCode.startsWith("0") ;
        }
      ).required(t("phone_required")),
  });


  // start functions

  const handleClose = () => {
    setOpenSignup(false)
    setShowPass(false)
  };
  const handleSubmit = async (values: signupReqType)=> {
    const deviceToken = await requestNotificationPermission().then((token) => token);
    const payload = {
      ...values,
      device_token: deviceToken,
      device_type: "web",
    };
    const result = await signupApi(payload);
    localStorage.setItem("token", result.data.token);
    console.log('Signup successful:');
    setOpenOtp(true)
    setOpenSignup(false)
    setShowPass(false)
    setUserData(result.data)
  }

  // end functions
  return (
    <div>
        <Dialog 
        open={openSignup}
        onClose={handleClose}
        slots={{
          transition: Transition,
        }}
        disableRestoreFocus
        maxWidth="md"
        fullWidth 
        >
          <div className='flex justify-between max-sm:flex-col pb-5'>
            <div className='w-full'>
              <DialogTitle>{t("create_new_account")}</DialogTitle>
              <DialogContent>
                <Formik
                initialValues={{ full_name: '', email: '', password: '', phone: '' }}
                validationSchema={SignupSchema}
                onSubmit={(values)=>handleSubmit(values)}
                >
              {({ values,touched, errors,setFieldValue }) => (
                <Form>
                  <div className="sm:flex gap-2 mt-2">
                    <InputField 
                    name="full_name" 
                    label={t("full_name")} 
                    className="sm:w-1/2 w-full"
                    type="text" 
                    />

                    <InputField 
                    name="email" 
                    label={t("email")} 
                    className="sm:w-1/2 w-full"
                    type="email" 
                    />
                  </div>

                  <div className="mt-5">
                    <InputField 
                    name="password" 
                    label={t("password")} 
                    className="w-full !mb-5"
                    type="password" 
                    showPasswordToggle
                    />
                    <PhoneField name="phone"/>
                  </div>

                  <DialogActions className={` ${i18n.language === "en" ? "!justify-start" : "!justify-start"}`}>
                    <Button className='w-full h-[62px] !bg-customerColor !text-white !rounded-full' type="submit">
                      {signupLoading 
                      ? <CircularProgress className='w-1 h-1'/>
                      :t("confirm")
                      }
                    </Button>
                  </DialogActions>
                </Form>
              )}
                </Formik>
              </DialogContent>
            </div>
          <div className='flex flex-col items-center'>
            <div className='w-[3px] h-full bg-[#D9D9D9]'></div>
            <div className=''>{i18n.language === "en" ? "Or" : "أو"}</div>
            <div className='w-[3px] h-full bg-[#D9D9D9]'></div>
          </div>
            <div className='w-full'>
            <DialogTitle className='flex gap-3'>
              <p className="whitespace-pre-line">{t("download_from_app")}</p>
            </DialogTitle>
            <DialogContent>
              <DialogActions>
                <Button className='w-full gap-2 h-[49px] !bg-[#EDEDED] !text-black !font-bold !rounded-full'>
                  <div>
                    <img src={apple} alt='no-photo'/>
                  </div>
                  <div>
                    {t("apple")}
                  </div>
                </Button>
              </DialogActions>
              <DialogActions>
                <Button className='w-full gap-2 h-[49px] !bg-[#EDEDED] !text-black !font-bold !rounded-full'>
                  <div>
                    <img src={google} alt='no-photo'/>
                  </div>
                  <div>
                    {t("google")}
                  </div>
                </Button>
              </DialogActions>
            </DialogContent>
            </div>
          </div>
        </Dialog>
    </div>
  )
}

export default Signup